/**
 * Text Field Type enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum TEXT_FIELD_TYPE {
	DEFAULT = "text",
	EMAIL = "email",
	PASSWORD = "password"
}

export type TEXT_FIELD_TYPE_string = keyof typeof TEXT_FIELD_TYPE;
